module.exports = __webpack_public_path__ + "img/ocular_pic.003f4c4b.png";